'use client'

/** Navbar messages icon + unread badge. Polls /api/messages?unread=1 while signed in. */

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { useSession } from 'next-auth/react'
import { Mail } from 'lucide-react'

export default function MessagesNavButton() {
  const { status } = useSession()
  const [unread, setUnread] = useState(0)

  useEffect(() => {
    if (status !== 'authenticated') return
    let alive = true
    const poll = async () => {
      if (document.visibilityState !== 'visible') return
      try { const r = await fetch('/api/messages?unread=1', { cache: 'no-store' }); if (r.ok && alive) setUnread((await r.json()).unread ?? 0) } catch { /* noop */ }
    }
    poll(); const iv = setInterval(poll, 30_000)
    return () => { alive = false; clearInterval(iv) }
  }, [status])

  if (status !== 'authenticated') return null
  return (
    <Link href="/messages" title="Messages" className="relative flex items-center rounded-lg px-2 py-2 transition-colors hover:bg-accent/50">
      <Mail className="h-5 w-5 text-foreground" />
      {unread > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-amber-500 px-1 text-[10px] font-bold text-black">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </Link>
  )
}
